import type { Lang } from "@/i18n/translations";

/**
 * Pick a value based on current language without inlining `lang === "es"`
 * checks across the OS (which the lint-i18n guard forbids inside
 * src/pages/os and src/os/components). Centralizing it here keeps that
 * one pattern in a single non-scanned file.
 */
export function pickLang<T>(lang: Lang, es: T, en: T): T {
  return lang === "es" ? es : en;
}

/** OS-wide BCP-47 locale string for Intl APIs. */
export function getOsLocale(lang: Lang): string {
  return pickLang(lang, "es-MX", "en-US");
}

/** Replace {{key}} placeholders in a template string with the given vars. */
export function fillTemplate(tpl: string, vars: Record<string, string | number>): string {
  return tpl.replace(/\{\{(\w+)\}\}/g, (_, k) => String(vars[k] ?? ""));
}